<script>
  import { onMount } from "svelte";
  import { getIndexByAttr, getByAttr } from "../helper/ListExtensions";

  import {
    RadioGroup,
    Card,
    Button,
    Radio,
    Input,
    FileSelect,
    Textarea
  } from "../components/ui";
  import { getBenefitsList } from "../helper/TextGenerator";

  import Icon from "svelte-awesome";
  import { faCheck, faPen } from "@fortawesome/free-solid-svg-icons";
  import { createEventDispatcher } from "svelte";

  let selectedItems = {
    pains: [],
    gains: [],
    jobs: [],
    features: []
  };
  onMount(() => {
    if (model.basedOn != null)
      selectedItems = JSON.parse(JSON.stringify(model.basedOn));
      console.log(selectedItems);
  });
  const dispatch = createEventDispatcher();
  const save = () => dispatch("save");
    const cancel = () => dispatch("cancel");

  export let model;
  export let data;
  export let index = 0;
  export let isEdit = false;

  let tmpBenefits = [];
  let selectedBenefitIndex;

  async function itemSelected(item, group) {
    let tmpIndex;
    if (selectedItems[group] != null)
      tmpIndex = getIndexByAttr(selectedItems[group], "value", item.value);
    if (tmpIndex > -1) selectedItems[group].splice(tmpIndex, 1);
    else selectedItems[group].push(item);

    getBenefitsList(selectedItems, data.document)
      .then(result => {
        tmpBenefits = result;
      })
      .catch(err => {
        console.log(`Error getBenefitsList: ${err}`);
      });
  }

  const createBenefit = () => {
    model.text = getByAttr(tmpBenefits, "value", selectedBenefitIndex).text;
    model.title = model.text;
    model.textShort = model.text;
    model.textLong = model.text;
    model.basedOn = JSON.parse(JSON.stringify(selectedItems)); //We need a deep copy here to not update existing values
    // model = newItem;
    //model.benefits.items = [...model.benefits.items, newItem].reverse();

    //selectedBenefitIndex = null;
    //save();
    //benefitVal++;
    index = 2;
  };
</script>

<div>
  <div class="bg-benefit text-white px-4 py-2 flex flex-row">
    <h2 class="text-2xl flex-grow">Create Benefit</h2>
    <Button on:submit={cancel}>Cancel</Button>

    {#if isEdit == true}
      <Button on:submit={save} primary={true}>Save</Button>
    {/if}
  </div>
  <div class="relative">
    <div
      class="bg-lightGray px-4 py-2 border-b-2 border-main"
      on:click={() => {
        index = 0;
      }}>
      <p>Bring together Pains & Gains with Features</p>
    </div>
    {#if index == 0}
      <div class="p-6">
        <div class="flex flex-row">
          <div class="w-1/4 overflow-y-auto" style="max-height:400px">
            {#each data.buyerPersona.pjg.pains.items as pain}
              <label class="flex-row flex items-center mt-4 mb-4 w-full">
                <input
                  type="checkbox"
                  id="pain_{pain.value}"
                  name="pain_{pain.value}"
                  checked={pain.checked}
                  on:change={() => {
                    itemSelected(pain, 'pains');
                  }} />
                <div class="px-3 py-1 bg-gray-400 ml-2 mr-2 text-xs rounded">
                  Pain
                </div>
                <p>{pain.text}</p>
              </label>
            {/each}
          </div>
          <div class="w-1/4 overflow-y-auto" style="max-height:400px">

            {#each data.buyerPersona.pjg.gains.items as gain}
              <label class="flex-row flex items-center mt-4 mb-4 w-full">
                <input
                  type="checkbox"
                  id="gain_{gain.value}"
                  name="gain_{gain.value}"
                  checked={gain.checked}
                  on:change={() => {
                    itemSelected(gain, 'gains');
                  }} />
                <div class="px-3 py-1 bg-gray-400 ml-2 mr-2 text-xs rounded">
                  Gain
                </div>
                <p>{gain.text}</p>
              </label>
            {/each}
            <!-- {#each data.buyerPersona.pjg.jobs.items as job}
              <label class="flex-row flex items-center mt-4 mb-4 w-full">
                <input
                  type="checkbox"
                  id="job_{job.value}"
                  name="job_{job.value}"
                  checked={job.checked}
                  on:change={() => {
                    itemSelected(job, 'jobs');
                  }} />
                <div class="px-3 py-1 bg-gray-400 ml-2 mr-2 text-xs rounded">
                  Job
                </div>
                <p>{job.text}</p>
              </label>
            {/each} -->
          </div>
          <div class="w-1/2 overflow-y-auto" style="max-height:400px">
            {#each data.featureGroups as group}
              {#each group.items as feature}
                <label class="flex-row flex items-center mt-4 mb-4 w-full">
                  <input
                    type="checkbox"
                    id="group_feature_{feature.value}"
                    name="group_feature_{feature.value}"
                    checked={feature.checked}
                    on:change={() => {
                      itemSelected(feature, 'features');
                    }} />
                  <div class="px-3 py-1 bg-gray-400 ml-2 mr-2 text-xs rounded">
                    Feature
                  </div>
                  <p>{feature.text}</p>
                </label>
              {/each}
            {/each}
          </div>
        </div>
        <div class="flex flex-row">
          <span class="flex-grow" />
          <Button
            primary={true}
            on:submit={() => {
              index = 1;
            }}>
            Next
          </Button>
        </div>
      </div>
    {/if}
    <div
      class="bg-lightGray px-4 py-2 border-b-2 border-main"
      on:click={() => {
        index = 1;
      }}>
      <p>Formula: Choose which copy formula works best</p>
    </div>
    {#if index == 1}
      <div class="p-6">
        <div>
          <h2 class="text-xl">Benefits</h2>
          <p class="text-sm text-gray-700">
            Select the features of your product/service that you want to
            highlight.
          </p>
        </div>
        <div class="overflow-y-auto p-1" style="max-height:400px">
          <RadioGroup>
            {#each tmpBenefits as item}
              <div class="relative flex flex-row">
                <Radio
                  value={item.value}
                  bind:group={selectedBenefitIndex}
                  class="pt-2 pb-2">
                  {item.text}
                </Radio>
              </div>
            {/each}
          </RadioGroup>
        </div>
        <div class="flex flex-row">
          <span class="flex-grow" />
          <Button primary={true} on:submit={createBenefit}>Next</Button>
        </div>
      </div>
    {/if}
    <div
      class="bg-lightGray px-4 py-2 border-b-2 border-main"
      on:click={() => {
        index = 2;
      }}>
      <p>Copy: Review and finetune the generated copy</p>

    </div>
    {#if index == 2}
      <div class="p-6">

        <div class="md:grid md:grid-cols-3 md:gap-6 mb-4">
          <div class="md:col-span-1">
            <h3 class="text-lg font-medium leading-6 text-gray-900">
              Headline
            </h3>
            <p class="mt-1 text-sm leading-5 text-gray-500">
              This information will be displayed publicly so be careful what you
              share.
            </p>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="grid grid-cols-3 gap-6">
              <div class="col-span-3 sm:col-span-2">
                <Textarea bind:model={model.title} />
              </div>
            </div>
          </div>
        </div>
        <div class="md:grid md:grid-cols-3 md:gap-6 mb-4">
          <div class="md:col-span-1">
            <h3 class="text-lg font-medium leading-6 text-gray-900">
              Short Description
            </h3>
            <p class="mt-1 text-sm leading-5 text-gray-500">
              This information will be displayed publicly so be careful what you
              share.
            </p>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="grid grid-cols-3 gap-6">
              <div class="col-span-3 sm:col-span-2">
                <Textarea bind:model={model.textShort} />
              </div>
            </div>
          </div>
        </div>
        <div class="md:grid md:grid-cols-3 md:gap-6 mb-4">
          <div class="md:col-span-1">
            <h3 class="text-lg font-medium leading-6 text-gray-900">
              Long Description
            </h3>
            <p class="mt-1 text-sm leading-5 text-gray-500">
              This information will be displayed publicly so be careful what you
              share.
            </p>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="grid grid-cols-3 gap-6">
              <div class="col-span-3 sm:col-span-2">
                <Textarea bind:model={model.textLong} />
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-row">
          <span class="flex-grow" />
          <Button
            primary={true}
            on:submit={() => {
              index = 3;
            }}>
            Next
          </Button>
        </div>
      </div>
    {/if}
    <div
      class="bg-lightGray px-4 py-2 border-b-2 border-main"
      on:click={() => {
        index = 3;
      }}>
      <p>Preview: Choose icons/images and get a live preview</p>
    </div>
    {#if index == 3}
      <div class="p-6">

        <FileSelect
          bind:model={model.image}
          class="sm:col-span-6"
          label="Image" />
        <div class="flex flex-row">
          <span class="flex-grow" />
          <Button on:submit={save}>Save</Button>

        </div>
      </div>
    {/if}
  </div>

  <!-- {#each model.benefits.items as benefit (benefit.value)}
    <div class="border-main rounded border-4 p-4 mt-4">
      <p class="text-2xl">{benefit.text}</p>
      {#each benefit.basedOn.pains as pain (pain.text)}
        <div class="flex-row flex mt-2 mb-2">
          <div class="px-3 py-1 bg-gray-400 ml-2 mr-2 text-xs rounded">
            Pain
          </div>
          {pain.text}
        </div>
      {/each}
      {#each benefit.basedOn.gains as gain}
        <div class="flex-row flex mt-2 mb-2">
          <div class="px-3 py-1 bg-gray-400 ml-2 mr-2 text-xs rounded">
            Gain
          </div>
          {gain.text}
        </div>
      {/each}
      {#each benefit.basedOn.jobs as job}
        <div class="flex-row flex mt-2 mb-2">
          <div class="px-3 py-1 bg-gray-400 ml-2 mr-2 text-xs rounded">Job</div>
          {job.text}
        </div>
      {/each}
      {#each benefit.basedOn.features as feature}
        <div class="flex-row flex mt-2 mb-2">
          <div class="px-3 py-1 bg-gray-400 ml-2 mr-2 text-xs rounded">
            Feature
          </div>
          {feature.text}
        </div>
      {/each}
    </div>
  {/each} -->

</div>
